import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Alert, Button, Dialog, DialogContent, DialogFooter, DialogHeader } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { FileSystemDocumentFileStatus } from 'shared/domains/apollo/generated/types';
export function StatusInformation(props) {
    const { status, onClose } = props;
    const getText = () => {
        switch (status) {
            case FileSystemDocumentFileStatus.Unsupported:
                return t({
                    message: 'Document has a unsupported format and is not available for download',
                    comment: 'Download dialog error alert message',
                });
            case FileSystemDocumentFileStatus.Pending:
                return t({
                    message: 'The document is being processed and is not available for download yet.',
                    comment: 'Download dialog error alert message',
                });
            case FileSystemDocumentFileStatus.Suspicious:
                return t({
                    message: 'The document could not be processed and is not available for download.',
                    comment: 'Download dialog error alert message',
                });
            case FileSystemDocumentFileStatus.Unknown:
            default:
                return t({
                    message: 'Download is currently not available.',
                    comment: 'Download dialog error alert message',
                });
        }
    };
    return (<Dialog>
      <DialogHeader title={t({ message: 'Download', comment: 'Download dialog header title' })} icon={<Falcon icon="download"/>}/>
      <DialogContent>
        <Alert appearance="info" title={t({
            message: 'Download is currently not available',
            comment: 'Download dialog error alert message',
        })} message={getText()}/>
      </DialogContent>
      <DialogFooter>
        <Button appearance="secondary" size="small" onClick={onClose}>
          <Trans comment="Download dialog cancel button label">Close</Trans>
        </Button>
      </DialogFooter>
    </Dialog>);
}
